module.exports = __webpack_public_path__ + "img/icon-users-black.98c81c39.svg";